exports.baseURL = "https://admin.tokchat.duckdns.org/";
exports.key = "5TIvw5cpc0";
exports.projectName = "Tok"
